import { render, staticRenderFns } from "./VOfferBanner.vue?vue&type=template&id=aa74b8cc&scoped=true&"
import script from "./VOfferBanner.vue?vue&type=script&lang=js&"
export * from "./VOfferBanner.vue?vue&type=script&lang=js&"
import style0 from "./VOfferBanner.vue?vue&type=style&index=0&id=aa74b8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa74b8cc",
  null
  
)

export default component.exports